import"./Baseline.css.ts.vanilla.css";import"./BlockTheme.css.ts.vanilla.css";var o="_1lkto10";export{o as blockTheme};
